import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export const useUiStore = create(
  devtools(
    persist(
      (set, get) => ({
        sidebarExpanded: false,
        wideLayout: false,
        redirectUrl: null,
        darkMode: false,
        pursuitCalendarView: false,
        pursuitTaskCalendarView: false,
        acknowledgedFeatures: {}, // used to show UI once

        acknowledgeFeature: (key) =>
          set((s) => ({
            acknowledgedFeatures: { ...s.acknowledgedFeatures, [key]: true },
          })),

        hasSeenFeature: (key) => !!get().acknowledgedFeatures[key],

        toggleSidebarExpanded: () =>
          set((state) => ({ sidebarExpanded: !state.sidebarExpanded })),
        toggleWideLayout: () =>
          set((state) => ({ wideLayout: !state.wideLayout })),

        toggleDarkMode: () =>
          set((state) => {
            const newDarkMode = !state.darkMode;

            if (newDarkMode) {
              document.documentElement.classList.add("dark");
              document.documentElement.classList.remove("light");
            } else {
              document.documentElement.classList.add("light");
              document.documentElement.classList.remove("dark");
            }

            return { darkMode: newDarkMode };
          }),

        togglePursuitTaskCalendarView: () =>
          set((state) => ({
            pursuitTaskCalendarView: !state.pursuitTaskCalendarView,
          })),

        togglePursuitCalendarView: () =>
          set((state) => ({
            pursuitCalendarView: !state.pursuitCalendarView,
          })),

        reset: () =>
          set({
            sidebarExpanded: false,
            wideLayout: false,
            redirectUrl: null,
            pursuitCalendarView: false,
            pursuitTaskCalendarView: false,
          }),
      }),
      {
        name: "ui-storage", // Unique name for localStorage
        onRehydrateStorage: () => (state) => {
          if (state?.darkMode) {
            document.documentElement.classList.add("dark");
            document.documentElement.classList.remove("light");
          } else {
            document.documentElement.classList.add("light");
            document.documentElement.classList.remove("dark");
          }
        },
      }
    ),
    {
      name: "UI-storage", // Redux DevTools
      enabled: process.env.NODE_ENV === "development",
    }
  )
);
